import { Component, ViewChild, TemplateRef, ElementRef, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

import { ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { AuthenticationService } from  './services/authentication/authentication.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
 

})
export class AppComponent implements OnInit , OnDestroy {
  title = 'cadence-ui';


  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
    //tab management
    channel : BroadcastChannel;
    tabId : String;
    condition: boolean = false;






  constructor(private idle: Idle, private keepalive: Keepalive, private router: Router,
    public appService: AuthenticationService , private confirmationService: ConfirmationService
      ,  private primengConfig: PrimeNGConfig) {
    idle.setIdle(60 * 30);
    idle.setTimeout(30);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.watch();

    this.appService.getUserLoggedIn().subscribe(userLoggedIn => {
      if (userLoggedIn) {
        idle.watch();
        this.timedOut = false;
      } else {
        idle.stop();
      }
    })

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
      // console.log(this.idleState);
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      // console.log(this.idleState);
      this.confirmationService.close();
      this.router.navigate(['/']);
    });

    idle.onIdleStart.subscribe(() => {
        this.idleState = 'You\'ve gone idle!'
        // console.log(this.idleState);
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will be logged out in ' + countdown + ' seconds!!'
      // console.log(this.idleState);
      this.confiemDialog(this.idleState);

    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());


    // tab Management

    this.channel = new BroadcastChannel('tab_management');
    this.tabId = Date.now().toString();


  }


  // tab management
  // ngOnInit(): void {
  //   this.incrementTabCount();
  //   window.addEventListener('beforeunload', this.handleTabClose.bind(this));
  // }

  // ngOnDestroy(): void {
  //   this.decrementTabCount();
  //   window.removeEventListener('beforeunload', this.handleTabClose.bind(this));
  // }

  // incrementTabCount(): void {
  //   const tabCount = parseInt(localStorage.getItem('tabCount') || '0', 10);
  //   localStorage.setItem('tabCount', (tabCount + 1).toString());
  // }

  // decrementTabCount(): void {
  //   const tabCount = parseInt(localStorage.getItem('tabCount') || '0', 10);
  //   if (tabCount > 0) {
  //     localStorage.setItem('tabCount', (tabCount - 1).toString());
  //   }
  // }

  // handleTabClose(event: Event): void {
  //   // this.decrementTabCount();
  //   // const tabCount = parseInt(localStorage.getItem('tabCount') || '0', 10);
  //   // if (tabCount === 0) {
  //   //   localStorage.clear();
  //   // }
  // }

  isLogin : boolean = false;

  getIsLoggedIn() : boolean {
    this.isLogin = this.appService.checkLoggedIn();
    if(this.isLogin){
      return true; ;
    }
    const token =  localStorage.getItem('token');
    if(!this.isLogin && token){
      return true;
    }else if(this.isLogin && !token){
      return false;
    }

  }


  // tab management
  ngOnInit(): void {

    this.primengConfig.setTranslation({
      ...this.primengConfig.getTranslation('en'),
      matchAll: 'Match All (AND)',
      matchAny: 'Match Any (OR)',
    });

    this.incrementTabCount();
    window.addEventListener('beforeunload', this.handleTabClose.bind(this));
    this.channel.onmessage = this.handleChannelMessage.bind(this);

  }

  ngOnDestroy(): void {
    this.decrementTabCount();
    window.removeEventListener('beforeunload', this.handleTabClose.bind(this));
    this.channel.close();
    localStorage.clear();
    sessionStorage.clear();
  }

  private incrementTabCount(): void {
    const tabCount = this.getTabCount();
    localStorage.setItem('tabCount', (tabCount + 1).toString());
    localStorage.setItem(`tab_${this.tabId}`, 'active');
    this.channel.postMessage({ type: 'tabOpened', id: this.tabId });
  }

  private decrementTabCount(): void {
    const tabCount = this.getTabCount();
    if (tabCount > 0) {
      localStorage.setItem('tabCount', (tabCount - 1).toString());
    }
    localStorage.removeItem(`tab_${this.tabId}`);
    this.channel.postMessage({ type: 'tabClosed', id: this.tabId });
  }

  private getTabCount(): number {
    return parseInt(localStorage.getItem('tabCount') || '0', 10);
  }

  private handleTabClose(event: BeforeUnloadEvent): void {
    this.decrementTabCount();
  }

  private handleChannelMessage(event: MessageEvent): void {
    if (event.data.type === 'tabOpened') {
      // Another tab was opened
      // console.log('Tab opened:', event.data.id);
    } else if (event.data.type === 'tabClosed') {
      // Another tab was closed
      // console.log('Tab closed:', event.data.id);
      this.cleanupOrphanedTabs();
    }
  }

  private cleanupOrphanedTabs(): void {
    const currentTabs = Object.keys(localStorage)
      .filter(key => key.startsWith('tab_'))
      .map(key => key.split('_')[1]);

    let tabCount = 0;
    currentTabs.forEach(tabId => {
      if (localStorage.getItem(`tab_${tabId}`) === 'active') {
        tabCount++;
      } else {
        localStorage.removeItem(`tab_${tabId}`);
      }
    });

    localStorage.setItem('tabCount', tabCount.toString());
  }





  //

  reset() {
    //this.idle.watch();
    this.timedOut = false;
  }


  stay() {
    this.reset();
  }

  logout() {
    // this.appService.logOut();

    this.appService.logOut().subscribe(
      response => {
        // console.log('Logged out successfully', response);
        // Redirect to login page or perform other actions
      },
      error => {
        console.error('Logout failed', error);
      }
    );

    this.router.navigate(['/']);
  }

  public confiemDialog(msg : string){
    this.confirmationService.confirm({
      message: msg,
      header: 'You\'ve gone idle!',
      icon: 'pi pi-info-circle',
      acceptLabel	: 'Logout',
      rejectLabel : 'Keep me',
       accept: () => {
        this.logout();
        // console.log("the looooog out done")
      },
      reject: () => {
        this.stay();
      }
  });
  }

}
